import {
  CampaignChannel,
  CampaignInvitation,
  Media,
  Scalars,
} from '@promoboxx/graphql-gateway-types'

export const PAID_AD_ENDING_THRESHOLD = 7 * 86400_000
export const BRAND_FUNDS_EXPIRING_SOON = 30 * 86400_000
export const MAX_PER_SECTION = 3

// TODO Should live in redux types.
export interface RandomAdFromRedux {
  id: Scalars['ID']['output']
  brand_id: Scalars['ID']['output']
  objective: string
  state: string
  starts_at: string
  ends_at: string
  title: string
  thumbnail: Media
  campaign_channels: CampaignChannel[]
  campaign_invitation: CampaignInvitation
  automated: boolean
  automated_now: boolean
  platforms: string
  created_at: string
  published_at: string
  type: string
  retailerId: Scalars['ID']['output']
  locations: unknown[]
  description: string
  startDate: string
  endDate: string
  thumbnailSrcId: string
  channels: {
    campaignId: Scalars['ID']['output']
    type: string
    channelCampaignId: Scalars['ID']['output']
    to: string
  }[]
  activateUrl: string
  isActivatable: boolean
  isActivated: boolean
  creditAmount: number
  brandLogo: string
  brandName: string
}
